// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + "222748fc2062f301d0f4" + ".bundle.js";
};